import React from 'react';

import ParticleBackground from '../../components/ParticleBackground';

import { globalAnimationStyles } from '../../styles/theme';
import {
  getCommonContainerStyles,
  getCommonTextStyles,
  getH1Style,
} from '../../styles/commonStyles';
import {
  useMobile,
  useScrollToTop,
  useThemeCssVars,
} from '../../styles/commonHooks';
import { getHowItWorksText } from '../../translations/howItWorks';

export default function HowItWorks({ lang, theme, isSamsungBrowser = false }) {
  const isMobile = useMobile();
  useScrollToTop();

  const themeVars = useThemeCssVars(theme, isSamsungBrowser);
  const containerStyles = getCommonContainerStyles(themeVars, isMobile);
  const h1Style = getH1Style(themeVars, isMobile, isSamsungBrowser);
  const text = getHowItWorksText(lang);

  const styles = {
    main: {
      flex: 1,
      textAlign: 'left',
      ...getCommonTextStyles(isMobile),
    },
    contentWrapper: {
      maxWidth: 'min(100%, 1080px)',
      margin: '0 auto',
    },
    paragraph: {
      marginBottom: '1.8em',
    },
    subtitle: {
      fontWeight: '600',
      margin: '2.4em 0 1.2em',
      fontSize: '1.18em',
    },
    notice: {
      marginTop: '3em',
      fontSize: '0.96em',
      opacity: 0.85,
      textAlign: 'center',
    },
    link: {
      color: themeVars.accent,
      textDecoration: 'underline',
      fontWeight: '500',
    },
  };

  return (
    <>
      <ParticleBackground theme={theme} />

      <div style={containerStyles.outer}>
        <div style={containerStyles.inner}>
          <main key={lang} style={styles.main}>
            <h1 style={h1Style} className="animate-on-mount">
              {text.pageTitle}
            </h1>

            <div style={styles.contentWrapper} className="animate-on-mount">
              <p style={styles.paragraph}>{text.intro}</p>

              <p style={styles.subtitle}>{text.sectionTitle}</p>

              <p style={styles.paragraph}>{text.body1}</p>

              <p style={styles.paragraph}>{text.body2}</p>

              <p style={styles.notice}>
                {text.gdprNotice}{' '}
                (
                <a href="/privacy-policy" style={styles.link}>
                  {text.gdprLink}
                </a>
                ).
              </p>
            </div>
          </main>
        </div>
      </div>

      <style jsx global>{globalAnimationStyles}</style>
    </>
  );
}